import AttributeParser from "../utils/AttributeParser";
import { getSharedStyleSheet } from './sharedStyleSheet.js';

class FileBrowserFile extends HTMLElement {
    static observedAttributes = ['id', 'department-id', 'project-id', 'path', 'title'];

    constructor() {
        super();
        this.browserRoot = null;
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open', delegatesFocus: true});

            // Share a single parsed stylesheet across all shadow roots
            getSharedStyleSheet().then(sheet => {
                this.shadowRoot.adoptedStyleSheets = [sheet];
            });

            this._wrapper = document.createElement('div');
            this._wrapper.className = 'file-browser-item-wrapper';
            this._wrapper.tabIndex = 0;
            this.shadowRoot.appendChild(this._wrapper);

            const folder = `<div class="file-browser-file"><div class="file-spacer"></div>
                <file-thumb size="micro"></file-thumb></div>`;
            this._wrapper.insertAdjacentHTML('beforeend', folder);

            this._item = this._wrapper.querySelector('.file-browser-file');
            this._thumb = this._wrapper.querySelector('file-thumb');

            this.setupEvents();
        }

        this.dynamicRender();
    }

    setupEvents() {
        this._wrapper.setAttribute('role', 'button');
        this._wrapper.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this._item.click();
            }
        });
        this._item.addEventListener('click', e => {
            if (!AttributeParser.parseBooleanAttribute(this.getAttribute('selectable') ?? false)) return;
            const id = +this.getAttribute('file-id') ?? -1;
            this.browserRoot.updateSelection(id, -1, '');
        });
    }

    dynamicRender() {
        if (!this._wrapper) return;

        this._wrapper.setAttribute('aria-label', this.getAttribute('file-title') ?? 'File');
        this._thumb.setAttribute('file-title', this.getAttribute('file-title') ?? '');
        this._thumb.setAttribute('src', this.getAttribute('thumbnail') ?? '');

        if (AttributeParser.parseBooleanAttribute(this.getAttribute('selectable') ?? false)) {
            this._thumb.classList.add('selectable');
        } else {
            this._thumb.classList.remove('selectable');
        }
    }

    setSelected(selected) {
        this._wrapper.setAttribute('aria-pressed', String(selected));
        if (selected) {
            this._item.classList.add('selected');
        } else {
            this._item.classList.remove('selected');
        }
    }

    setBrowserRoot(root) {
        this.browserRoot = root;
    }

    itemWithID(id) {
        if (+this.getAttribute('file-id') === +id) {
            return {
                id: +this.getAttribute('file-id'),
                department_id: +this.getAttribute('department-id'),
                path: this.getAttribute('path'),
                project_id: +this.getAttribute('project-id'),
                thumbnail: this.getAttribute('thumbnail'),
                department_name: this.getDepartmentName(),
                title: this.getAttribute('file-title')
            };
        }

        return null;
    }

    getDepartmentName() {
        if (+this.getAttribute('department-id') < 1) return '(No Department)';

        const dept = this.browserRoot.itemWithPath('/', +this.getAttribute('department-id'));

        if (dept) {
            return dept.title;
        }

        return null;
    }
}

customElements.define('file-browser-file', FileBrowserFile);

